<bit-dialog [title]="activeFilter()?.label() ?? ('filter' | i18n)" dialogSize="small">
  @if (activeFilter()) {
    <button
      bitDialogHeaderStart
      type="button"
      bitIconButton="bwi-angle-left"
      buttonType="primaryGhost"
      size="small"
      [label]="'back' | i18n"
      (click)="back()"
    ></button>
  }
  <div bitDialogContent>
    @if (activeFilter(); as filter) {
      <div [class]="optionListClasses">
        <ng-container *ngTemplateOutlet="filter.optionsTemplate()!"></ng-container>
      </div>
    } @else {
      <div class="tw-flex tw-flex-col tw-gap-2">
        @for (filter of filters; track filter.key()) {
          <button
            type="button"
            class="tw-flex tw-w-full tw-items-center tw-gap-3 tw-rounded-lg tw-border tw-border-solid tw-border-secondary-300 tw-bg-transparent tw-p-3 tw-text-start tw-text-main hover:tw-bg-secondary-100 focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-inset focus-visible:tw-ring-border-focus"
            (click)="select(filter)"
          >
            <span
              class="tw-size-2 tw-flex-none tw-rounded-full"
              [class.tw-bg-bg-brand]="filter.active()"
            ></span>
            @if (filter.icon(); as icon) {
              <bit-icon [name]="icon" class="tw-flex-none" aria-hidden="true"></bit-icon>
            }
            <span class="tw-flex tw-min-w-0 tw-flex-1 tw-items-center tw-gap-1">
              <span class="tw-truncate">{{ rowLabel(filter) }}</span>
              @if (filter.summaryLabels().length) {
                <span
                  bitOverflowList
                  [gap]="4"
                  class="tw-flex tw-min-w-0 tw-flex-1 tw-items-center tw-text-fg-body"
                  #overflow="bitOverflowList"
                >
                  @for (label of filter.summaryLabels(); track label; let last = $last) {
                    <span bitOverflowItem class="tw-whitespace-nowrap">{{
                      last ? label : label + ","
                    }}</span>
                  }
                  <span bitOverflowTrigger class="tw-whitespace-nowrap"
                    >+{{ overflow.overflow().length }}</span
                  >
                </span>
              }
            </span>
            @if (filter.optionsTemplate()) {
              <bit-icon name="bwi-angle-right" class="tw-flex-none tw-text-muted"></bit-icon>
            }
          </button>
        }
      </div>
    }
  </div>

  <ng-container bitDialogFooter>
    @if (activeFilter()) {
      <button bitButton buttonType="primary" type="button" class="tw-ms-auto" (click)="back()">
        {{ "done" | i18n }}
      </button>
    } @else {
      @if (selectedCount()) {
        <span class="tw-text-sm tw-text-muted">{{
          "filtersSelected" | i18n: selectedCount()
        }}</span>
        <button
          bitButton
          buttonType="secondary"
          type="button"
          class="tw-ms-auto"
          startIcon="bwi-clear"
          (click)="clearAllAndKeepFocus()"
        >
          {{ "clearAll" | i18n }}
        </button>
      }
      <button
        bitButton
        buttonType="primary"
        type="button"
        [class.tw-ms-auto]="!selectedCount()"
        (click)="close()"
        #doneButton
      >
        {{ "done" | i18n }}
      </button>
    }
  </ng-container>
</bit-dialog>
